import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { Subhead02Text } from '../typography/typography';
import { CardChatStyle } from './card-chat-style';

interface ICardChat {
  title: string;
  started: boolean;
  unread: number;
  onClick: () => void;
}

const CardChat: React.FC<ICardChat> = ({ title, started, unread, onClick }) => {
  return (
    <CardChatStyle onClick={() => onClick()}>
      <div className="card-chat-left">
        <div className="card-chat-left__title">
          <Subhead02Text weight={600}>{title}</Subhead02Text>
        </div>
      </div>
      <div className="card-chat-right">
        {started && unread > 0 ? (
          <div className="card-chat-messages">
            <span>{unread}</span>
          </div>
        ) : (
          <ArrowForwardIcon />
        )}
      </div>
    </CardChatStyle>
  );
};

export default CardChat;
